import axios from 'axios'
import { CommonParamsWithQuery, CommonSearchResponse } from '@/api/resources/common/shared/models/common.models'

class AuditSearchService {
    async search(params: CommonParamsWithQuery): Promise<CommonSearchResponse> {
        const response = await axios.get<CommonSearchResponse>(`/audit/shipments/search`, { params })
        return response.data
    }
}

export const auditSearchService = new AuditSearchService()
